import { RecordingRTCPool } from "./recording-rtc-pool";
import { protocol } from "..";
import type { RTCConfig } from "../config/rtc-config";
import type { ArtichokeConfig } from "../config/config";
import { LoggerFactory } from "../logger/logger-factory";
import { ArtichokeApi } from "../artichoke/artichoke-api";
import { WebRTCStats } from "./stats/webrtc-stats";
import { LoggerService } from "../logger/logger-service";

export class RecordingRTCPoolFactory {
  constructor(
    private rtcConfig: RTCConfig,
    private artichokeConfig: ArtichokeConfig,
    private loggerFactory: LoggerFactory,
    private loggerService: LoggerService,
    private artichokeApi: ArtichokeApi,
    private webRTCStats: WebRTCStats
  ) {}

  public create(callId: protocol.ID): RecordingRTCPool {
    this.loggerService.debug(`creating RecordingRTCPool for call ${callId}`);

    const keepAliveInterval = this.artichokeConfig.keepAliveIntervalMs || 30000;

    return new RecordingRTCPool(
      callId,
      this.rtcConfig,
      this.loggerFactory,
      this.artichokeApi,
      this.webRTCStats,
      keepAliveInterval
    );
  }
}
